import React, { useState } from "react";
import { Form, Button, Row, Col, Drawer, Upload, Table, message } from "antd";
import useStore from "../../../../store";
import { observer } from "mobx-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle, faExclamationTriangle, faTimes } from "@fortawesome/free-solid-svg-icons";
import { UploadIcon } from "../../../../config/IconsConfig";
import { vsmVariants, vsmNotify } from "../../../../config/messages";
import debounce from "lodash/debounce";


const ImportComponent = observer((props) => {
	const [form] = Form.useForm();
	const [saving, setSaving] = useState();
	const [importSaving, setimportSaving] = useState()
	const [disabled, setDisabled] = useState(true);
	const [fileList, updateFileList] = useState([]);
	// Handle submit and call function to save new record
	const {
		ManageVariantStore
	} = useStore();

	// Handle submit and call function to save new record
	const handleSubmit = (data) => {
		const formData = new FormData();
		if (fileList.length > 0) {
			formData.append("variant_sheet", fileList[0]?.originFileObj ? fileList[0]?.originFileObj : fileList[0]);
		}

		setSaving(true);
		ManageVariantStore.VerifyImport(formData)
			.then((data) => {
				vsmNotify.success({
					message: data.STATUS.NOTIFICATION[0],
				});
			})
			.catch((e) => {
				if (e.errors) {
					form.setFields(e.errors);
				}
			})
			.finally(() => setSaving(false));
	};

	const handleImportProceed = () => {
		if (ManageVariantStore.dropdown_varify_list) {
			setimportSaving(true)
			const data = {
				variant_sheet: ManageVariantStore.dropdown_varify_list.variant_sheet,
				variants: ManageVariantStore.dropdown_varify_list.variants
			}
			ManageVariantStore.ProceedImport(data)
				.then((data) => {
					close();
					vsmNotify.success({
						message: data.STATUS.NOTIFICATION[0],
					});
				})
				.catch((e) => {
					if (e.errors) {
						form.setFields(e.errors);
					}
				})
				.finally(() => setimportSaving(false));
		}
	}

	// check for valid form values then accordingly make save button disable / enable
	const handleChange = () => {
		form
			.validateFields()
			.then((data) => {
				setDisabled(false);
			})
			.catch((e) => {
				setDisabled(true);
			});
	};

	const uploadButton = (
		<div className="upload_btn">
			<UploadIcon />
			<p>Drag files to upload, or browse</p>
		</div>
	);

	const tableColumn = [
		{
			title: "Comment",
			key: "comment",
			width: 300,
			className: "text-left",
			render: (text, record) => (
				<>
					{
						record.comment.map((item, index) => {
							return (
								<p key={index} style={{ color: record.verified && record.verified === "0" ? "red" : "green" }}>
									<FontAwesomeIcon icon={record.verified && record.verified === "0" ? faExclamationTriangle : faCheckCircle} /><span>{record.verified && record.verified === "0" ? ("Error: " + item) : item}</span>
								</p>
							);
						})
					}
				</>
			),
		},
		{
			title: "Brand",
			dataIndex: "brand",
			key: "brand",
		},
		{
			title: "Model",
			dataIndex: "model",
			key: "model",
		},
		{
			title: "CC",
			dataIndex: "cc",
			key: "cc",
		},
		{
			title: "Transmission Type",
			dataIndex: "transmission_type",
			key: "transmission_type",
		},
		{
			title: "Fuel Option",
			dataIndex: "fuel_option",
			key: "fuel_option",
		},
		{
			title: "Is Metalic",
			dataIndex: "metalic",
			key: "metalic",
		},
		{
			title: "Is CNG",
			dataIndex: "cng",
			key: "cng",
		},
		{
			title: "Passengers",
			dataIndex: "passengers",
			key: "passengers",
		},
		{
			title: "Weight (KG)",
			dataIndex: "weight_kg",
			key: "weight_kg",
		},
		{
			title: "Build",
			dataIndex: "build",
			key: "build",
		},
		{
			title: "Name",
			dataIndex: "name",
			key: "name",
		},
		{
			title: "Mfg. Name",
			dataIndex: "mfg_name",
			key: "mfg_name",
		},
		{
			title: "Make Year",
			dataIndex: "make_year",
			key: "make_year",
		},
		{
			title: "VIN Year",
			dataIndex: "vin_year",
			key: "vin_year",
		},
		{
			title: "RTO Individual (%)",
			dataIndex: "rto_individual",
			key: "rto_individual",
		},
		{
			title: "RTO Company (%)",
			dataIndex: "rto_company",
			key: "rto_company",
		},
		{
			title: "RTO Bharat Passing (%)",
			dataIndex: "rto_bharat_passing",
			key: "rto_bharat_passing",
		},
		{
			title: "Basic Price",
			dataIndex: "basic_price",
			key: "basic_price",
		},
		{
			title: "Discount",
			dataIndex: "discount",
			key: "discount",
		},
		{
			title: "Discounted Price",
			dataIndex: "discounted_price",
			key: "discounted_price",
		},
		{
			title: "Transportation Insurance",
			dataIndex: "transportation_insurance",
			key: "transportation_insurance",
		},
		{
			title: "Road Delivery Charges",
			dataIndex: "road_delivery_charges",
			key: "road_delivery_charges",
		},
		{
			title: "Dealer Margin",
			dataIndex: "dealer_margin",
			key: "dealer_margin",
		},
		{
			title: "Handling Charges",
			dataIndex: "handling_charges",
			key: "handling_charges",
		},
		{
			title: "Total Charges",
			dataIndex: "total_charges",
			key: "total_charges",
		},
		{
			title: "Ex-Showroom without GST",
			dataIndex: "ex_showroom_without_gst",
			key: "ex_showroom_without_gst",
		},
		{
			title: "GST (%)",
			dataIndex: "gst_per",
			key: "gst_per",
		},
		{
			title: "GST Charges",
			dataIndex: "gst",
			key: "gst",
		},
		{
			title: "Ex-Showroom",
			dataIndex: "ex_show_price",
			key: "ex_show_price",
		},
		{
			title: "CSD Ex-Showroom",
			dataIndex: "csd_ex_show_price",
			key: "csd_ex_show_price",
		},
		{
			title: "Insurance",
			dataIndex: "ins_amt",
			key: "ins_amt",
		},
		{
			title: "Is Active",
			dataIndex: "is_active",
			key: "is_active",
		},
	];

	const eventProps = {
		onChange: debounce(({ fileList: newFileList }) => {
			updateFileList(newFileList);
			handleChange()
		}, 500),
		fileList,
		beforeUpload: (file) => {
			let isType = file.type === "text/csv" || file.type === "application/vnd.ms-excel"
			if (!isType) {
				message.error(`Please select valid CSV file to import.`);
				return true;
			} else {
				updateFileList([file]);
				return false;
			}
		},
	};

	// Handle on remove image
	const onRemoveImage = () => {
		form.setFields([{ name: "variant_sheet", errors: [] }]);
		updateFileList([]);
	};

	// reset form and close add form
	const close = () => {
		props.close();
		form.resetFields();
		setDisabled(true);
		updateFileList([]);
		ManageVariantStore.dropdown_varify_list = null;
		ManageVariantStore.dropdown_supplier_list = null;
	};

	return (
		<Drawer
			className="addModal"
			title="Import"
			width="80%"
			visible={props.visible}
			closeIcon={<FontAwesomeIcon icon={faTimes} />}
			onClose={close}
			footer={[
				<Button
					key="2"
					htmlType="button"
					className="cancelBtn mr-35"
					onClick={close}
				>
					Cancel
				</Button>,
			]}
		>
			<div className="import_trans_main">
				<Form
					form={form}
					id="importTransactionForm"
					onFinish={handleSubmit}
					labelCol={{ span: 24 }}
					onChange={handleChange}
				>
					{/* <div className="download_sample_sec">
						<p>
							Please download a sample file format, this will help you to create a new draft considering what information is required, what should be the sequence and formatting a value if necessary. This way we can minimize error while importing a Inquiry listing.
						</p>
						<Button shape="round" type="link" href={AUTH.company && AUTH.company.branding.inquiry_import_sample_file} icon={<DownloadOutlined />}>
							Download Sample
						</Button>
					</div> */}
					<div className="upload_verify_sec">
						<Row justify="space-between" align="middle" gutter={30}>
							<Col xs={{ span: 24 }} sm={{ span: 14 }}>
								<div className="upload_left_sec">
									<p>
										Hope you are ready with an Variant List, Please upload file draft.
									</p>
									<Form.Item>
										<Button
											htmlType="submit"
											type="primary"
											loading={saving}
											disabled={disabled}
										>
											Upload & Verify
										</Button>
									</Form.Item>
								</div>
							</Col>
							<Col xs={{ span: 24 }} sm={{ span: 8 }}>
								<Form.Item name="variant_sheet" rules={vsmVariants.validation.variant_sheet}>
									<Upload.Dragger
										accept=".csv"
										showUploadList={true}
										multiple={false}
										fileList={fileList}
										onRemove={onRemoveImage}
										name="variant_sheet"
										rules={vsmVariants.validation.variant_sheet}
										{...eventProps}
									>
										{uploadButton}
									</Upload.Dragger>
								</Form.Item>
							</Col>
						</Row>
					</div>
					{
						ManageVariantStore.dropdown_varify_list &&
						<div className="import_table">
							<Table
								columns={tableColumn}
								dataSource={ManageVariantStore.dropdown_varify_list.variants}
								pagination="false"
								scroll={{ x: 3500, y: 300 }}
							/>
						</div>
					}
				</Form>
				{
					ManageVariantStore.dropdown_varify_list && ManageVariantStore.dropdown_varify_list.errors !== 0 &&
					<div className="import_total_sec">
						<div className="import_total_wrap">
							<Row gutter={30} justify="space-between" align="middle">
								<Col xs={{ span: 24 }} sm={{ span: 10 }}>
									<div className="import_total_text">
										<p>
											There are several entries with error, please resolve them and try again.
										</p>
									</div>
								</Col>
								<Col xs={{ span: 24 }} sm={{ span: 14 }}>
									<div className="import_total_block">
										<Row gutter={20}>
											<Col xs={{ span: 24 }} sm={{ span: 8 }}>
												<div className="import_block import_total">
													<div className="import_block_title">Total</div>
													<p>{ManageVariantStore.dropdown_varify_list.total_entries}</p>
												</div>
											</Col>
											<Col xs={{ span: 24 }} sm={{ span: 8 }}>
												<div className="import_block import_verified">
													<div className="import_block_title">Verified OK</div>
													<p>{ManageVariantStore.dropdown_varify_list.verified_ok}</p>
												</div>
											</Col>
											<Col xs={{ span: 24 }} sm={{ span: 8 }}>
												<div className="import_block import_error">
													<div className="import_block_title">Errors</div>
													<p>{ManageVariantStore.dropdown_varify_list.errors}</p>
												</div>
											</Col>
										</Row>
									</div>
								</Col>
							</Row>
						</div>
					</div>}
				{
					ManageVariantStore.dropdown_varify_list && ManageVariantStore.dropdown_varify_list.errors === 0 &&
					<div className="import_total_sec">
						<div className="import_total_wrap">
							<Row gutter={30} justify="space-between" align="middle">
								<Col xs={{ span: 24 }} sm={{ span: 14 }}>
									<div className="import_total_block">
										<Row gutter={20}>
											<Col xs={{ span: 24 }} sm={{ span: 8 }}>
												<div className="import_block import_total">
													<div className="import_block_title">Total</div>
													<p>{ManageVariantStore.dropdown_varify_list.total_entries}</p>
												</div>
											</Col>
											<Col xs={{ span: 24 }} sm={{ span: 8 }}>
												<div className="import_block import_verified">
													<div className="import_block_title">Verified OK</div>
													<p>{ManageVariantStore.dropdown_varify_list.verified_ok}</p>
												</div>
											</Col>
											<Col xs={{ span: 24 }} sm={{ span: 8 }}>
												<div className="import_block import_error">
													<div className="import_block_title">Errors</div>
													<p>{ManageVariantStore.dropdown_varify_list.errors}</p>
												</div>
											</Col>
										</Row>
									</div>
								</Col>
								<Col xs={{ span: 24 }} sm={{ span: 10 }}>
									<div className="import_total_text">
										<p>Verification is successfully completed, please import variant list.</p>
										<Button htmlType="button" onClick={handleImportProceed} className="" loading={importSaving} >
											Proceed with Import
										</Button>
									</div>
								</Col>
							</Row>
						</div>
					</div>
				}
			</div>
		</Drawer>
	);
});

export default ImportComponent;
